module.exports = __webpack_public_path__ + "img/banner-3-new.bf10d46d.svg";